import React, { useEffect, useRef, useState } from 'react';
import { isMobile } from 'react-device-detect';
import toast from "react-hot-toast";
import { Tooltip } from 'react-tooltip';
import ArchiveIcon from 'assets/archive_icon.svg?react';
import filled_like from 'assets/filled_like.svg';
import photo_pic from 'assets/has_image.svg';
import heart_img from 'assets/heart_img.svg';
import mask from 'assets/mask.svg';
import premium_pic from 'assets/purple_crown.svg';
import { useUpdatePrivateGameMutation } from 'services/api/gamesApi';
import styled from 'styled-components';

import CommonHelper from '../../../helpers/CommonHelper';

const GameCard = props => {
  const {
    item = {},
    isLikedByMe,
    likesToShow,
    isLiking,
    shouldShowLikes,
    hasSubscription = false,
    isVisibleTagSection = false,
    onItemClick = Function.prototype,
    refetchPrivateGames,
  } = props;


  const containerRef = useRef(null);
  const videoRef = useRef();
  const [isVisible, setIsVisible] = useState(false);
  const [shouldLoadVideo, setShouldLoadVideo] = useState(false);
  const [updatePrivateGame] = useUpdatePrivateGameMutation();
  const handleTagClick = () => {
    return null;
    // Поговорили с Антоном и обсудили,
    // что этот функционал в будущем может понадобится, поэтому не выпиливаю, а оставляю коммент
    // e.stopPropagation();
    // const formattedTagName = tagName.split(' ').join('_');
    // navigate(`/tag/:${formattedTagName}`);
  };
  const isArchived = item?.isArchived ?? false;

  const handleArchiveGame = async (e) => {
    const getSuccessArchiveMessage = () => isArchived ? 'Game has been unarchived successfully' : 'Game has been archived successfully';
    const getErrorArchiveMessage = () => isArchived ? 'Error while unarchiving the game' : 'Error while archiving the game';

    e.stopPropagation();
    try {
      await updatePrivateGame({ id: item.id, isArchived: !isArchived });
      await refetchPrivateGames();
      toast.success(getSuccessArchiveMessage());
    } catch (error) {
      toast.error(getErrorArchiveMessage());
      throw error;
    }
  };

  const isPrivateScenario = !item?.isPublic;

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (isMobile) {
            setIsVisible(entry.isIntersecting);
            setShouldLoadVideo(true);
          }
          if (entry.isIntersecting && !isMobile) {
            setShouldLoadVideo(true);
          }
        });
      },
      { threshold: 0.5 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);


  useEffect(() => {
    if (videoRef.current) {
      if (isVisible) {
        videoRef.current.play().catch(() => { });
      } else {
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
      }
    }
  }, [isVisible]);


  return (
    <Card
      className="max-w-max cursor-pointer overflow-hidden shadow-lg"
      onClick={() => onItemClick(item)}
      ref={containerRef}
      onMouseEnter={() => {
        if (item?.videoCoverUrl && !isMobile) {
          setIsVisible(true);
        }
      }}
      onMouseLeave={() => {
        if (item?.videoCoverUrl && !isMobile) {
          setIsVisible(false);
        }
      }}
    >
      <CardTop>
        <Tooltip
          id={`has-photo-tooltip-${item.id}`}
          opacity={1}
          className="shadow-lg"
          content={
            <p className='max-w-[200px] font-["Nunito_Sans"]'>
              This icon indicates that the scenario includes photos. You can’t request them; they
              appear automatically to illustrate the scene as you progress through the scenario.
            </p>
          }
        />
        <HasPhoto className={'mr-4'}>
          {item?.hasPhotos && (
            <img
              data-tooltip-id={`has-photo-tooltip-${item.id}`}
              src={photo_pic}
              style={{ height: '36px' }}
            />
          )}
        </HasPhoto>

        {!item?.isFree && (
          <img src={premium_pic} style={{ height: '36px' }} className={''} />
        )}
      </CardTop>

      {item?.videoCoverUrl && shouldLoadVideo && (
        <CardVideo
          visible={isVisible}
          ref={videoRef}
          muted
          playsInline
          preLoad={isMobile ? "none" : "auto"}
          preload={isMobile ? "none" : "auto"}
          onEnded={() => setIsVisible(false)}
          loading="lazy"
        >
          <source src={item?.videoCoverUrl} type="video/mp4" />
        </CardVideo>
      )}
      {item.coverUrl ? (
        <CardImage
          className="w-full"
          src={CommonHelper.getFilesCdnUrl(item.coverUrl)}
          alt={`Cover for ${item.name}`}
          loading="lazy"
        />
      ) : (
        <DefaultImage src={mask} alt="default cover" loading="lazy" />
      )}

      {!item?.isLocked || !hasSubscription && (
        <CardLockOverlay />
      )}

      <BottomPlaceholder className="px-6 py-4">
        <div>
          <CardName className="mb-2 text-xl font-bold">{item.publicName}</CardName>
          {isVisibleTagSection && (
            <TagsWrapper>
              {item?.tags.map(tag => {
                return (
                  <Tag key={tag} onClick={e => handleTagClick(e, tag)}>
                    {tag}
                  </Tag>
                );
              })}
            </TagsWrapper>
          )}
          <CardDescription className={`text-white ${isPrivateScenario ? 'limited' : ''}`}>{item.publicDescription}</CardDescription>
        </div>
        <ButtonPlaceholder className={'flex flex-row items-center justify-between'}>
          {isPrivateScenario && (
            <ArchiveButton
              isArchived={isArchived}
              onClick={(e) => handleArchiveGame(e)}>
              <ArchiveIcon />
              {isArchived ? 'Unarchive' : 'Archive'}
            </ArchiveButton>)}
          {shouldShowLikes && (
            <div
              className={'flex flex-row items-center'}
              style={{ opacity: shouldShowLikes ? (isLiking ? 0.5 : 1) : 0 }}
            >
              <img src={isLikedByMe ? filled_like : heart_img} className={'mr-2'} />
              <span className={'font-bold text-gray-500'} style={{ color: 'rgba(169, 169, 169, 1)' }}>
                {`${likesToShow}`}
              </span>
            </div>
          )}
          {!isArchived && (
            <>
              {item?.isLocked && !hasSubscription ? (
                <UnlockButton
                  className={'cursor-pointer hover:opacity-80'}
                  onClick={() => {
                    onItemClick(item);
                  }}
                >
                  {'Unlock'}
                </UnlockButton>
              ) : (
                <Button
                  className={'cursor-pointer hover:opacity-80'}
                  onClick={() => {
                    CommonHelper.yandexTrackEvent('scenario_card_click', {
                      name: item?.publicName
                    });
                    onItemClick(item);
                  }}
                >
                  {'Play'}
                </Button>
              )}
            </>
          )}
        </ButtonPlaceholder>
      </BottomPlaceholder>
    </Card>
  );
};

export default GameCard;

const CardImage = styled.img`
  object-fit: cover;
  height: 200px;
`;

const DefaultImage = styled.img`
  object-fit: contain;
  width: 100%;
  height: 200px;
  padding: 24px;
  opacity: 0.7;
`;

const CardVideo = styled.video`
  z-index: 3;
  object-fit: cover;
  width: 100%;
  height: 200px;
  position: absolute;
  top: 0;
  left: 0;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  opacity: ${props => (props?.visible ? '1' : '0')};
`;

const CardLockOverlay = styled.div`
  width: 100%;
  top: 0px;
  left: 0px;
  z-index: 3;
  position: absolute;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-bottom: 4px solid;
  border-image-source: linear-gradient(90deg, #9E5EEE 0%, #B759EA 32%, #C65DE9 66%, #B885F4 100%);
  border-image-slice: 1;
`;

const CardName = styled.h2`
  font-family: Raleway;
  font-size: 20px;
  line-height: 22px;
  font-weight: bold;
  margin-bottom: 12px;
`;

const CardDescription = styled.p`
  min-height: 140px;
  font-family: Nunito Sans;
  font-size: 16px;
  line-height: 18px;
  
  &.limited {
    display: -webkit-box;
    -webkit-line-clamp: 8;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const Card = styled.div`
  background: rgba(29, 29, 29, 1);
  color: white;
  height: 100%;

  font-family: 'Unbounded', sans-serif;
  font-optical-sizing: auto;

  font-size: 16px;
  position: relative;
  transition: transform 0.3s;
  border-radius: 10px;

  :hover {
    transform: scale3d(1.03, 1.03, 1);
    box-shadow: rgba(175, 61, 169, 0.57);
  }
`;

const CardTop = styled.div`
  position: absolute;
  top: 15px;
  right: 0px;
  left: 0px;
  z-index: 6;
  padding-left: 15px;
  padding-right: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const HasPhoto = styled.div`
  height: 40px;
  border-radius: 10px;
  color: rgba(255, 126, 85, 1);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

const BottomPlaceholder = styled.div`
  min-height: 200px;
  height: calc(100% - 200px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media (max-width: 720px) {
    min-height: auto;
  }
`;

const Button = styled.div`
  background: rgba(255, 126, 85, 1);
  border-radius: 1000px;
  color: white;
  font-weight: bold;
  padding-left: 25px;
  padding-right: 25px;
  height: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-family: Nunito Sans;
`;

const ArchiveButton = styled.div`
  color: #A9A9A9;
  font-family: Nunito Sans;
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: ${props => props.isArchived ? '100%' : 'auto'};
  gap: 8px;
  border-radius: ${props => props.isArchived ? '86px' : '0'};
  padding: 8px 16px;
  background: ${props => props.isArchived ? '#282828' : 'transparent'};
`;

const UnlockButton = styled.div`
  background: transparent;
  color: rgba(158, 94, 238, 1);

  border: 1px solid rgba(158, 94, 238, 1);

  border-radius: 1000px;
  font-weight: bold;
  padding-left: 25px;
  padding-right: 25px;
  height: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-family: Nunito Sans;

  :hover {
    background: rgba(158, 94, 238, 1);
    color: white;
  }
`;

/* Rectangle 403 */

const ButtonPlaceholder = styled.div`
  margin-top: 30px;
  margin-bottom: 10px;

  @media (max-width: 720px) {
    position: relative;
  }
`;

const Tag = styled.div`
  font-family: Nunito Sans;
  font-size: 12px;
  font-weight: 400;
  padding: 2px 4px;
  border-radius: 6px;
  cursor: pointer;
  background: #131313;
  color: #a9a9a9;
`;

const TagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 20px;
`;

const AudioButtonContainer = styled.div`
  position: absolute;
  top: 182px;
  right: 15px;
  z-index: 3;

  & > button > img {
    width: 36px;
  } 
`;
